import Styles from './style.module.scss';

export default function SuggestHeader({ titleText, titleDesc }) {
  return (
    <div className={Styles.header}>
      <header className={Styles.title}>{titleText}</header>
      <div className={Styles.text}>{titleDesc}</div>
      <div className={Styles.oneLine}></div>
    </div>
  );
}
